"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

var _buttonSpinner = _interopRequireDefault(require("../assets/images/button-spinner.svg"));

var _checkmark = _interopRequireDefault(require("../assets/images/checkmark.svg"));

var _arrowWhite = _interopRequireDefault(require("../assets/images/arrow-white.svg"));

var _SubmitStates = require("../Constant/SubmitStates");

var _Icon, _BgColor;

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background: url(", ") no-repeat center ", ";\n  min-width: 67px;\n  min-height: 60px;\n  border: 1px solid ", ";\n  cursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Icon = (_Icon = {}, (0, _defineProperty2.default)(_Icon, _SubmitStates.DEFAULT, _arrowWhite.default), (0, _defineProperty2.default)(_Icon, _SubmitStates.PENDING, _buttonSpinner.default), (0, _defineProperty2.default)(_Icon, _SubmitStates.SUCCESS, _checkmark.default), _Icon);
var BgColor = (_BgColor = {}, (0, _defineProperty2.default)(_BgColor, _SubmitStates.DEFAULT, _Constant.Color.DARK_PURPLE), (0, _defineProperty2.default)(_BgColor, _SubmitStates.PENDING, _Constant.Color.DARK_PURPLE), (0, _defineProperty2.default)(_BgColor, _SubmitStates.SUCCESS, _Constant.Color.TEAL), _BgColor);

var StatusButton = _styledComponents.default.button(_templateObject(), function (props) {
  return Icon[props.status];
}, function (props) {
  return BgColor[props.status];
}, _Constant.Color.WHITE);
/** Button that displays submit status */


var SubmitButton = function SubmitButton(props) {
  return /*#__PURE__*/_react.default.createElement(StatusButton, props);
};

SubmitButton.propTypes = {
  /** Form submit status. */
  status: _propTypes.default.string
};
SubmitButton.defaultProps = {
  status: _SubmitStates.DEFAULT
};
var _default = SubmitButton;
exports.default = _default;